import React, { useEffect, useRef, useState } from 'react';
import { FusionPanelPreview } from './FusionPanelPreview';
import { FusionScenePreview } from './FusionScenePreview';
import { FusionVortexPreview } from './FusionVortexPreview';
import { getDevicePixelRatio } from '../../utils/devicePixelRatio';
const defaultFusionOptions = {
    textOptions: {
        rtextEnabled: false,
    },
};
export function FusionPreview({ children, cimDoc, user, view, renderOptions, onError, onPaint, onFusionPaint, fusionOptions = defaultFusionOptions, transformCimDocForServerFallback, }) {
    const [width, setWidth] = useState();
    const widthContainerRef = useRef(null);
    useEffect(() => {
        var _a;
        if (!((_a = widthContainerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement)) {
            throw new Error('Container ref not found');
        }
        const resizeObserver = new ResizeObserver((entries) => {
            setWidth(entries[0].contentRect.width * getDevicePixelRatio());
        });
        resizeObserver.observe(widthContainerRef.current.parentElement);
        return () => {
            resizeObserver.disconnect();
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: widthContainerRef }),
        width && view.type === 'panel' && (React.createElement(FusionPanelPreview, { children: children, cimDoc: cimDoc, user: user, page: view.panel.page, width: width, onError: onError, onPaint: onPaint, onFusionPaint: onFusionPaint, fusionOptions: fusionOptions })),
        width && view.type === 'scene' && (React.createElement(FusionScenePreview, { children: children, cimDoc: cimDoc, user: user, view: view, width: width, onError: onError, onPaint: onPaint, onFusionPaint: onFusionPaint, fusionOptions: fusionOptions, transformCimDocForServerFallback: transformCimDocForServerFallback })),
        view.type === 'vortex' && (React.createElement(FusionVortexPreview, { children: children, cimDoc: cimDoc, view: view, user: user, renderOptions: renderOptions, onError: onError, onPaint: onPaint, onFusionPaint: onFusionPaint, fusionOptions: fusionOptions }))));
}
//# sourceMappingURL=FusionPreview.js.map